import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ComplaintDetailService } from './complaint-detail.service';
import { Subscription } from 'rxjs';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-complain-detail',
  templateUrl: './complain-detail.component.html',
  styleUrls: ['./complain-detail.component.scss']
})
export class ComplainDetailComponent implements OnInit {
  complaintDetail: any;
  timelineData: any;
  incidentData: any;
  messages: any[];
  commentData:any;

  routeparams: any;
  user: any;
  subscription: Subscription;
  closeResult: string;
  Attachment: any;
  AllImages: any;
  AllVideos:any;
  data: string;
  voiceNotes: any;
  constructor(private complaintDetailService: ComplaintDetailService,
    private modalService: NgbModal) {

  }

  open(content) {
    this.modalService.open(content).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  openCentred(content) {
    this.modalService.open(content, {centered: true});
  }

  openSmall(content) {
    this.modalService.open(content, {
      size: 'sm'
    });
  }

  openLarge(content) {
    this.modalService.open(content, {
      size: 'lg'
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  ngOnInit() {

    this.complaintDetail = this.complaintDetailService.complaintDetail
    console.log('this.complaintDetail', this.complaintDetail);
    
    this.timelineData = this.complaintDetailService.timelineData
    this.incidentData = this.complaintDetailService.incidentData
    this.AllImages = this.complaintDetailService.complaintDetail.images
    this.AllVideos = this.complaintDetailService.complaintDetail.videos
    this.Attachment = this.complaintDetailService.complaintDetail.attachment
    this.voiceNotes = this.complaintDetailService.complaintDetail.voice_file[0]
    this.routeparams = this.complaintDetailService.routeParams
    this.messages = this.complaintDetailService.commentData
    this.user = localStorage.getItem('user_id')

    this.complaintDetailService.getMessage().subscribe(message => {
      if (message) {
        this.messages.push(message);
      } else {
        this.messages = [];
      }
    })
  }

  trimChatData(ev) {
    this.data = ev.target.value.trim();
  }

  reply() {
    console.log('data', this.data)
    if (this.data) {
      this.data = this.data.trim();
      if (!this.data) {
        return;
    }
      this.complaintDetailService.comment({ comment: this.data, incident_id: this.routeparams })
        .then(() => {
          this.data = ''
        });
    }
    
  }

}
